import { AwesomeEvent, ComponentAPI } from '@philips-emr/tws-core';
import { AbortableCloseEventListener, Closeable, CloseEventListener } from '@philips-emr/tws-core/lib/component/types';

export default class HpmsCustomDialogAPI extends ComponentAPI<{ visible: boolean }> implements Closeable {

  /** @event */
  @AwesomeEvent
  public onBeforeClose = new AbortableCloseEventListener();

  /** @event */
  @AwesomeEvent
  public onClose = new CloseEventListener();

  public isVisible(): boolean {
    return this.state.visible;
  }

  public close(): void {
    let close = true;

    const abort = (): void => { close = false; };
    this.onBeforeClose.fire({ abort });

    close && this.onClose.fire();
  }

  public setVisible(visible: boolean): void {
    this.setState({ visible });
  }

}
